<app-tab [tabs]="tabs"></app-tab>